module.exports = __webpack_public_path__ + "static/cx-mobile-screen1-b2200ead06fb88805885846e36d22ac0.jpeg";